import ClientRepository from "@adapters/salesFeatures/Clients/repositories/Clients";
import PartnerOverviewRepository from "@adapters/salesFeatures/Partner360/repositories/PartnerOverview";
export default (function (http) {
    return {
        clients: new ClientRepository(http),
        partnerOverview: new PartnerOverviewRepository(http),
    };
});
